module.exports = __webpack_public_path__ + "static/icon-e436a5925396c6d6cac0bdccb4381bde.png";